<!-- Contact Us Section -->
<section class="py-5 bg-light">
  <div class="container">
    <h2 class="text-center fw-bold mb-4">Contact Us</h2>
    <p class="text-center mb-5">We’d love to hear from you. Feel free to reach out for inquiries, support, or feedback.</p>
    <div class="row g-4">
      <!-- Contact Details -->
      <div class="col-md-6">
        <div class="bg-white shadow-sm rounded p-4 h-100">
          <h5 class="fw-bold mb-3">Get in Touch</h5>
          <p><i class="fas fa-map-marker-alt text-primary me-2"></i>No.4024 DBCS Building  opp: Dubai Grand Hotel Al Qusais  Dubai UAE,[PO Box: 80958]</p>
          <p><i class="fas fa-phone-alt text-primary me-2"></i>0558096834 / 0582679803</p>
          <p><i class="fas fa-envelope text-primary me-2"></i>leslyak@hmcits.com</p>
          <p><i class="fas fa-clock text-primary me-2"></i>Mon - Fri: 9:00 AM - 6:00 PM</p>
          <div class="mt-4">
            <a href="https://facebook.com" class="text-primary me-3" target="_blank"><i class="fab fa-facebook-f fa-lg"></i></a>
            <a href="https://youtube.com" class="text-danger me-3" target="_blank"><i class="fab fa-youtube fa-lg"></i></a>
            <a href="https://twitter.com" class="text-info" target="_blank"><i class="fab fa-twitter fa-lg"></i></a>
          </div>
        </div>
      </div>

      <!-- Contact Form -->


            <div class="col-md-6">
        <div class="bg-white shadow-sm rounded p-4 h-100">
          <h5 class="fw-bold mb-3">Send Us a Message</h5>
          <form
            action="https://formspree.io/f/mdkelryq"
            method="POST"
          >
            <div class="mb-3">
              <label for="name" class="form-label">Your Name</label>
              <input type="text" class="form-control" name="name"  id="name" placeholder="Enter your name" required>
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Your Email</label>
              <input type="email" class="form-control" name="email"  id="email" placeholder="Enter your email" required>
            </div>
            <div class="mb-3">
              <label for="message" class="form-label">Your Message</label>
              <textarea  name="message" class="form-control" id="message" rows="5" placeholder="Enter your message" required></textarea>
            </div>
            <button type="submit" class="btn btn-primary w-100">Send Message</button>
          </form>
          <p id="responseMessage"></p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Map Section -->
<section class="py-5">
  <div class="container">
    <h5 class="fw-bold mb-3 text-center">Find Us Here</h5>
    <div class="ratio ratio-16x9">
<!--      <iframe-->
<!--        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.401030628056!2d55.3776042!3d25.2711623!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5f5f5f5f5f5f%3A0x1234567890abcdef!2sNo.4024%20DBCS%20Building%20opp%3A%20Dubai%20Grand%20Hotel%20Al%20Qusais%20Dubai%20UAE%20PO%20Box%2080958!5e0!3m2!1sen!2sus!4v1711890000000!5m2!1sen!2sus"-->
<!--        width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy">-->
<!--      </iframe>-->
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3618.1168520598853!2d55.3823177!3d25.273164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d21497884c5%3A0xacab8e6f88c33a7!2sAl%20Faiz%20Documents%20Clearing!5e0!3m2!1sen!2s!4v1712134567890"
        width="600"
        height="450"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>



    </div>
  </div>
</section>
